import React, { Component, useEffect, useState } from 'react';
import Header from '../Component/Layout/Header';
import { connect } from 'react-redux';
import axios from 'axios';
import { dataUser } from './Helpers/util';
import moment from 'moment';
import mixpanel from 'mixpanel-browser';
import { toast } from 'react-toastify';
import { Layout } from 'antd';
import Sidebar from './Layout/Sidebar';
import CustomHeader from '../Component/Layout/Header';
import SwSelect from './Common/SwReactSelect/SwReactSelect';
import SwToggleButtons from './Common/SwToggleButtons/SwToggleButtons';
import SwButton from './Common/SwButtons/SwButtons';
import { useNavigate } from 'react-router-dom';
import SwNoData from './Common/NoData/NoData';
function LegalAndCompliance({ }) {
  const userDataLocal = dataUser();
  var UserObj = JSON.parse(userDataLocal);
  const [userId, setUserId] = useState();
  const [UserData, setUserData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [companyid, setCompanyId] = useState(UserObj.company_id);
  const [aggrementDetails, setAggrementDetails] = useState({});
  const [tab, setTab] = useState('all');
  const [docAllData, setDocAllData] = useState([]);
  const [panCardData, setPanCardData] = useState([]);
  const [photoIdData, setPhotoIdData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [aggrementDocumentData, setAggrementDocumentData] = useState([]);
  const [businessLicenseData, setBusinessLicenseData] = useState([]);
  const [incorporationData, setIncorporationData] = useState([]);
  const [termAndConditionData, setTermAndConditionData] = useState([]);
  const [loiData, setLoiData] = useState([]);
  const [expansionData, setExpansionData] = useState([]);
  const [signatureData, setSignatureData] = useState([]);
  const [handoverData, setHandoverData] = useState([]);
  const [personAddressData, setPersonAddressData] = useState([]);
  const [boardResolutionData, setBoardResolutionData] = useState([]);

  const navigate = useNavigate();
  const getUserAlternateId = () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    axios
      .get(
        `${process.env.REACT_APP_PROD_URL
        }getData/getAllAgreements?companyId=${companyid}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(res => {
        if (res.data.status !== 'fail') {
          const userData = res.data.data;
          setUserData(userData);

          if (userData && userData.length > 0) {
            // Ensure userData is defined and has items
            setUserId(userData[0]['_id']);
          }
        } else {
          toast.error(res.data.message, {});
        }
      });
  };

  const getAggrementDetailsById = () => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    axios
      .get(
        `${process.env.REACT_APP_PROD_URL
        }getData/getAgreements?agreementId=${userId}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(res => {
        setPanCardData([]);
        setPhotoIdData([]);
        setAddressData([]);
        setAggrementDocumentData([]);
        setBusinessLicenseData([]);
        setIncorporationData([]);
        setTermAndConditionData([]);
        setLoiData([]);
        setExpansionData([]);
        setSignatureData([]);
        setHandoverData([]);
        setPersonAddressData([]);
        setBoardResolutionData([]);
        if (res.data.data.data.length > 0)
          setAggrementDetails(res.data.data.data[0]);
        setDocAllData(res.data.docs);
        res.data.data.docs.map(items => {
          if (items.type == 'PAN_CARD') {
            setPanCardData([...panCardData, items]);
          }
          if (items.type == 'PHOTO_ID') {
            setPhotoIdData([...photoIdData, items]);
          }
          if (items.type == 'ADDRESS_PROOF') {
            setAddressData([...addressData, items]);
          }
          if (items.type == 'AGREEMENT_DOCUMENT') {
            setAggrementDocumentData([...aggrementDocumentData, items]);
          }
          if (items.type == 'BUSINESS_LICENSE') {
            setBusinessLicenseData([...businessLicenseData, items]);
          }
          if (items.type == 'INCORPORATION_CERTIFICATE') {
            setIncorporationData([...incorporationData, items]);
          }
          if (items.type == 'TERMS_AND_CONDITIONS') {
            setTermAndConditionData([...termAndConditionData, items]);
          }
          if (items.type == 'LOI') {
            setLoiData([...loiData, items]);
          }
          if (items.type == 'EXPANSION_DOCUMENT') {
            setExpansionData([...expansionData, items]);
          }
          if (items.type == 'SIGNED_AGREEMENT') {
            setSignatureData([...signatureData, items]);
          }
          if (items.type == 'HANDOVER') {
            setHandoverData([...handoverData, items]);
          }
          if (items.type == 'PERSON_ADDRESS') {
            setPersonAddressData([...personAddressData, items]);
          }
          if (items.type == 'BOARD_RESOLUTION') {
            setBoardResolutionData([...boardResolutionData, items]);
          }
        });
      });
  };

  const CompanyView = () => {
    if (UserObj) {
      mixpanel.track('Company Profile Page View', {
        PageName: 'Company Profile',
        UserEmail: UserObj.email,
        UserName: UserObj.fname + ' ' + UserObj.lname,
        UserId: UserObj.rec_id,
        CompanyId: UserObj.company_id,
        CompanyName: UserObj.company_name,
        Type: 'Company',
      });
    }
  };
  useEffect(() => {
    CompanyView();
  }, []);

  const changeUser = e => {
    setUserId(e.target.value);
  };

  useEffect(() => {
    if (userId) {
      getAggrementDetailsById();
    }
  }, [userId]);

  useEffect(() => {
    getUserAlternateId();
  }, []);

  const setTabset = val => {
    setTab(val);
  };

  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState);
  };

  return (
    <>
      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          <div class="PageContent">
            {/* <!-- Normal --> */}
            <div class="NewCompliancePage">
              <div class="row">
                <div className="SwHeading">
                  <h2>Company Profile</h2>
                </div>
              </div>
              <div class="agreementDetails1">
                <div class="row ">
                  <div class="col-md-12">
                    <div className="agreementDetails1_Headers">
                      <div className="SwSubHeading Hv2">
                        <h4 className='mb-0'>Agreement details</h4>
                      </div>

                      <label className="agreementDetailsListLabel ms-5">
                        Select
                      </label>

                      <div style={{ width: '290px' }}>
                        <SwSelect
                          placeholder="Select Agreement"
                          options={UserData.map((item, i) => ({
                            label:
                              item.alternateId && item.alternateId !== ''
                                ? item.alternateId
                                : `Agreement Doc ${i + 1}`,
                            value: item._id,
                          }))}
                          value={
                            UserData.map((item, i) => ({
                              label:
                                item.alternateId && item.alternateId !== ''
                                  ? item.alternateId
                                  : `Agreement Doc ${i + 1}`,
                              value: item._id,
                            })).find(opt => opt.value === userId) || null
                          }
                          onChange={selectedOption =>
                            changeUser({
                              target: {
                                name: 'agreement',
                                value: selectedOption?.value || '',
                              },
                            })
                          }
                          isClearable={false}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 px-3">
                    <div class="agreementDetails1Box">
                      <table class="table table-borderless">
                        <tbody>
                          <tr>
                            <td class="labl">Agreement Id:</td>
                            <td class="Dta">
                              {aggrementDetails?.alternateId
                                ? aggrementDetails?.alternateId
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">Location:</td>
                            <td class="Dta">
                              {aggrementDetails?.location?.locationNameTally
                                ? aggrementDetails?.location?.locationNameTally
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">Sales Spoc:</td>
                            <td class="Dta">
                              {aggrementDetails?.createdBy?.name
                                ? aggrementDetails?.createdBy?.name
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">Admin SPOC:</td>
                            <td class="Dta">
                              {aggrementDetails?.contactPerson
                                ? aggrementDetails?.contactPerson
                                : '-'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-3 px-2">
                    <div class="agreementDetails1Box">
                      <table class="table table-borderless">
                        <tbody>
                          <tr>
                            <td class="labl">Start Date:</td>
                            <td class="Dta">
                              {aggrementDetails?.startDate
                                ? moment(aggrementDetails?.startDate).format(
                                  ' Do  MMMM YYYY',
                                )
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">End Date:</td>
                            <td class="Dta">
                              {aggrementDetails?.endDate
                                ? moment(aggrementDetails?.endDate).format(
                                  ' Do  MMMM YYYY',
                                )
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">Lock-in Period:</td>
                            <td class="Dta">
                              {aggrementDetails?.lockInPeriod
                                ? aggrementDetails?.lockInPeriod
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">Notice Period:</td>
                            <td class="Dta">
                              {aggrementDetails?.noticePeriod
                                ? aggrementDetails?.noticePeriod
                                : '-'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-md-5 px-3">
                    <div class="agreementDetails1Box">
                      <table class="table table-borderless">
                        <tbody>
                          <tr>
                            <td class="labl">Billing Address:</td>
                            <td class="Dta">
                              {aggrementDetails?.location?.address
                                ? aggrementDetails?.location?.address
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">SPOC Mail:</td>
                            <td class="Dta">
                              {aggrementDetails?.createdBy?.email
                                ? aggrementDetails?.createdBy?.email
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">SPOC Mobile:</td>
                            <td class="Dta">
                              {aggrementDetails?.telephone
                                ? aggrementDetails?.telephone
                                : '-'}
                            </td>
                          </tr>
                          <tr>
                            <td class="labl">Service Provider Address:</td>
                            <td class="Dta">
                              {aggrementDetails?.location?.address
                                ? aggrementDetails?.location?.address
                                : '-'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="DocumentStatusContainer">
                <div class="row">
                  <div class="col-md-6 ">
                    <div className='SwSubHeading Hv2'><h3 class="">Document status</h3></div>

                  </div>

                </div>
                <div className="DocStatusTabs">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tab-btn-row SwToogleButtonContainer">
                        <SwToggleButtons
                          id="doc-tab-all"
                          name="doc-tabs"
                          value="all"
                          size="sm"
                          checked={tab === 'all'}
                          onChange={() => setTabset('all')}
                        >
                          All
                        </SwToggleButtons>

                        <SwToggleButtons
                          id="doc-tab-kyc"
                          name="doc-tabs"
                          value="kyc"
                          size="sm"
                          checked={tab === 'kyc'}
                          onChange={() => setTabset('kyc')}
                        >
                          KYC Documents
                        </SwToggleButtons>

                        <SwToggleButtons
                          id="doc-tab-legal"
                          name="doc-tabs"
                          value="legal"
                          size="sm"
                          checked={tab === 'legal'}
                          onChange={() => setTabset('legal')}
                        >
                          Legal Documents
                        </SwToggleButtons>

                        <SwToggleButtons
                          id="doc-tab-handover"
                          name="doc-tabs"
                          value="handover"
                          size="sm"
                          checked={tab === 'handover'}
                          onChange={() => setTabset('handover')}
                        >
                          Handover Checklist
                        </SwToggleButtons>
                      </div>
                    </div>
                  </div>
                </div>
                {tab == 'all' ? (
                  <div class="row">
                    {/* <!-- Pending Doc Status Card --> */}
                    {panCardData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {panCardData[0]?.createdDate &&
                            moment(panCardData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">PAN Card</div>
                              <div class="DocStatus">
                                {panCardData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {panCardData[0]?.createdDate
                                ? moment(panCardData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {panCardData[0]?.createdBy?.name
                                ? '| By :  ' + panCardData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {panCardData[0]?.modifiedDate
                                ? moment(panCardData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : panCardData[0]?.createdDate
                                  ? panCardData[0]?.createdDate
                                  : 'N/A'}
                              {panCardData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                panCardData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {panCardData[0]?.url != '' &&
                            panCardData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {panCardData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>
                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={panCardData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Verified Doc Status Card --> */}
                    {photoIdData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {photoIdData[0]?.createdDate &&
                            photoIdData[0]?.createdDate &&
                            moment(photoIdData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Photo Id Proof</div>
                              <div class="DocStatus">
                                {photoIdData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {photoIdData[0]?.createdDate
                                ? moment(photoIdData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {photoIdData[0]?.createdBy?.name
                                ? '| By :  ' + photoIdData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {photoIdData[0]?.modifiedDate
                                ? moment(photoIdData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : photoIdData[0]?.createdDate
                                  ? photoIdData[0]?.createdDate
                                  : 'N/A'}
                              {photoIdData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                photoIdData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {photoIdData[0]?.url != '' &&
                            photoIdData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {photoIdData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={photoIdData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Verified Doc Status Card --> */}
                    {addressData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {addressData[0]?.createdDate &&
                            moment(addressData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Address Proof</div>
                              <div class="DocStatus">
                                {addressData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {addressData[0]?.createdDate
                                ? moment(addressData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {addressData[0]?.createdBy?.name
                                ? '| By :  ' + addressData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {addressData[0]?.modifiedDate
                                ? moment(addressData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : addressData[0]?.createdDate
                                  ? addressData[0]?.createdDate
                                  : 'N/A'}
                              {addressData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                addressData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {addressData[0]?.url != '' &&
                            addressData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {addressData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>
                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={addressData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Pending Doc Status Card --> */}
                    {personAddressData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {personAddressData[0]?.createdDate &&
                            moment(personAddressData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">
                                Address Proof of Authorized Person
                              </div>
                              <div class="DocStatus">
                                {personAddressData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {personAddressData[0]?.createdDate
                                ? moment(
                                  personAddressData[0]?.createdDate,
                                ).format('Do  MMMM YYYY , h:mA')
                                : 'N/A'}{' '}
                              {personAddressData[0]?.createdBy?.name
                                ? '| By :  ' +
                                personAddressData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {personAddressData[0]?.modifiedDate
                                ? moment(
                                  personAddressData[0]?.modifiedDate,
                                ).format('h:mA, Do  MMMM YYYY')
                                : personAddressData[0]?.createdDate
                                  ? personAddressData[0]?.createdDate
                                  : 'N/A'}
                              {personAddressData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                personAddressData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {personAddressData[0]?.url != '' &&
                            personAddressData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {personAddressData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={personAddressData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Verified Doc Status Card --> */}
                    {aggrementDocumentData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {aggrementDocumentData[0]?.createdDate &&
                            moment(aggrementDocumentData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Aggrement Document</div>
                              <div class="DocStatus">
                                {aggrementDocumentData[0]?.status ==
                                  'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {aggrementDocumentData[0]?.createdDate
                                ? moment(
                                  aggrementDocumentData[0]?.createdDate,
                                ).format('Do  MMMM YYYY , h:mA')
                                : 'N/A'}{' '}
                              {aggrementDocumentData[0]?.createdBy?.name
                                ? '| By :  ' +
                                aggrementDocumentData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {aggrementDocumentData[0]?.modifiedDate
                                ? moment(
                                  aggrementDocumentData[0]?.modifiedDate,
                                ).format('h:mA, Do  MMMM YYYY')
                                : aggrementDocumentData[0]?.createdDate
                                  ? aggrementDocumentData[0]?.createdDate
                                  : 'N/A'}
                              {aggrementDocumentData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                aggrementDocumentData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {aggrementDocumentData[0]?.url != '' &&
                            aggrementDocumentData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {aggrementDocumentData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>
                                {/* <a class="ViewBTN1" target="_blank" href={aggrementDocumentData[0]?.url} role="button">View</a> */}
                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={aggrementDocumentData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Verified Doc Status Card --> */}
                    {boardResolutionData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {aggrementDetails?.boardResolutionData?.createdDate &&
                            moment(
                              aggrementDetails?.boardResolutionData?.createdDate,
                            ).format('YYYY-MM-DD') >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Board Resolution</div>
                              <div class="DocStatus">
                                {aggrementDetails?.boardResolutionData
                                  ?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {aggrementDetails?.boardResolutionData
                                ?.createdDate
                                ? moment(
                                  aggrementDetails?.boardResolutionData
                                    ?.createdDate,
                                ).format('Do  MMMM YYYY , h:mA')
                                : 'N/A'}{' '}
                              {aggrementDetails?.boardResolutionData?.createdBy
                                ?.name
                                ? '| By :  ' +
                                aggrementDetails?.boardResolutionData
                                  ?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {aggrementDetails?.boardResolutionData
                                ?.modifiedDate
                                ? moment(
                                  aggrementDetails?.boardResolutionData
                                    ?.modifiedDate,
                                ).format('h:mA, Do  MMMM YYYY')
                                : aggrementDetails?.boardResolutionData
                                  ?.createdDate
                                  ? aggrementDetails?.boardResolutionData
                                    ?.createdDate
                                  : 'N/A'}
                              {aggrementDetails?.boardResolutionData?.createdBy
                                ?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                aggrementDetails?.boardResolutionData
                                  ?.createdBy?.name
                                : ''}
                            </p>{' '}
                          </div>
                          {aggrementDetails?.boardResolutionData?.url != '' &&
                            aggrementDetails?.boardResolutionData?.url !=
                            undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {aggrementDetails?.boardResolutionData?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={
                                    aggrementDetails?.boardResolutionData?.url
                                  }
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Verified Doc Status Card --> */}
                    {businessLicenseData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {businessLicenseData[0]?.createdDate &&
                            moment(businessLicenseData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Business License</div>
                              <div class="DocStatus">
                                {businessLicenseData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {businessLicenseData[0]?.createdDate
                                ? moment(
                                  businessLicenseData[0]?.createdDate,
                                ).format('Do  MMMM YYYY , h:mA')
                                : 'N/A'}{' '}
                              {businessLicenseData[0]?.createdBy?.name
                                ? '| By :  ' +
                                businessLicenseData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {businessLicenseData[0]?.modifiedDate
                                ? moment(
                                  businessLicenseData[0]?.modifiedDate,
                                ).format('h:mA, Do  MMMM YYYY')
                                : businessLicenseData[0]?.createdDate
                                  ? businessLicenseData[0]?.createdDate
                                  : 'N/A'}
                              {businessLicenseData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                businessLicenseData[0]?.createdBy?.name
                                : ''}
                            </p>{' '}
                          </div>
                          {businessLicenseData[0]?.url != '' &&
                            businessLicenseData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {businessLicenseData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={businessLicenseData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Verified Doc Status Card --> */}
                    {incorporationData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {incorporationData[0]?.createdDate &&
                            moment(incorporationData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">
                                Incorporation Certificate
                              </div>
                              <div class="DocStatus">
                                {incorporationData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {incorporationData[0]?.createdDate
                                ? moment(
                                  incorporationData[0]?.createdDate,
                                ).format('Do  MMMM YYYY , h:mA')
                                : 'N/A'}{' '}
                              {incorporationData[0]?.createdBy?.name
                                ? '| By :  ' +
                                incorporationData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {incorporationData[0]?.modifiedDate
                                ? moment(
                                  incorporationData[0]?.modifiedDate,
                                ).format('h:mA, Do  MMMM YYYY')
                                : incorporationData[0]?.createdDate
                                  ? incorporationData[0]?.createdDate
                                  : 'N/A'}
                              {incorporationData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                incorporationData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {incorporationData[0]?.url != '' &&
                            incorporationData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {incorporationData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={incorporationData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!-- Verified Doc Status Card --> */}
                    {termAndConditionData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {termAndConditionData[0]?.createdDate &&
                            moment(termAndConditionData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">T&C Document</div>
                              <div class="DocStatus">
                                {termAndConditionData[0]?.status ==
                                  'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {termAndConditionData[0]?.createdDate
                                ? moment(
                                  termAndConditionData[0]?.createdDate,
                                ).format('Do  MMMM YYYY , h:mA')
                                : 'N/A'}{' '}
                              {termAndConditionData[0]?.createdBy?.name
                                ? '| By :  ' +
                                termAndConditionData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {termAndConditionData[0]?.modifiedDate
                                ? moment(
                                  termAndConditionData[0]?.modifiedDate,
                                ).format('h:mA, Do  MMMM YYYY')
                                : termAndConditionData[0]?.createdDate
                                  ? termAndConditionData[0]?.createdDate
                                  : 'N/A'}
                              {termAndConditionData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                termAndConditionData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {termAndConditionData[0]?.url != '' &&
                            termAndConditionData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {termAndConditionData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={termAndConditionData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {expansionData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {expansionData[0]?.createdDate &&
                            moment(expansionData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Addendum Document</div>
                              <div class="DocStatus">
                                {expansionData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {expansionData[0]?.createdDate
                                ? moment(expansionData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {expansionData[0]?.createdBy?.name
                                ? '| By :  ' + expansionData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {expansionData[0]?.modifiedDate
                                ? moment(expansionData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : expansionData[0]?.createdDate
                                  ? expansionData[0]?.createdDate
                                  : 'N/A'}
                              {expansionData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                expansionData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {expansionData[0]?.url != '' &&
                            expansionData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {expansionData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={expansionData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {loiData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {loiData[0]?.createdDate &&
                            moment(loiData[0]?.createdDate).format('YYYY-MM-DD') >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">LOI Document</div>
                              <div class="DocStatus">
                                {loiData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {loiData[0]?.createdDate
                                ? moment(loiData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {loiData[0]?.createdBy?.name
                                ? '| By :  ' + loiData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {loiData[0]?.modifiedDate
                                ? moment(loiData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : loiData[0]?.createdDate
                                  ? loiData[0]?.createdDate
                                  : 'N/A'}
                              {loiData[0]?.createdBy?.name
                                ? ',' + ' ' + ' ' + loiData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {loiData[0]?.url != '' &&
                            loiData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {loiData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={loiData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {expansionData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {expansionData[0]?.createdDate &&
                            moment(expansionData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Expansion Document</div>
                              <div class="DocStatus">
                                {expansionData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {expansionData[0]?.createdDate
                                ? moment(expansionData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {expansionData[0]?.createdBy?.name
                                ? '| By :  ' + expansionData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {expansionData[0]?.modifiedDate
                                ? moment(expansionData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : expansionData[0]?.createdDate
                                  ? expansionData[0]?.createdDate
                                  : 'N/A'}
                              {expansionData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                expansionData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {expansionData[0]?.url != '' &&
                            expansionData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {expansionData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={expansionData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {signatureData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {signatureData[0]?.createdDate &&
                            moment(signatureData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Signed Aggrement</div>
                              <div class="DocStatus">
                                {signatureData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {signatureData[0]?.createdDate
                                ? moment(signatureData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {signatureData[0]?.createdBy?.name
                                ? '| By :  ' + signatureData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {signatureData[0]?.modifiedDate
                                ? moment(signatureData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : signatureData[0]?.createdDate
                                  ? signatureData[0]?.createdDate
                                  : 'N/A'}
                              {signatureData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                signatureData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {signatureData[0]?.url != '' &&
                            signatureData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {signatureData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={signatureData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {handoverData.length > 0 ? (
                      <div class="col-md-4">
                        <div class="DocStatusCards">
                          {handoverData[0]?.createdDate &&
                            moment(handoverData[0]?.createdDate).format(
                              'YYYY-MM-DD',
                            ) >
                            moment()
                              .subtract(1, 'months')
                              .format('YYYY-MM-DD') ? (
                            <div class="BadgeForNew">New</div>
                          ) : (
                            ''
                          )}{' '}
                          <div class="DocStatusCardsHead">
                            <div class="d-flex justify-content-between align-items-center">
                              <div class="DocType">Handover Checklist</div>
                              <div class="DocStatus">
                                {handoverData[0]?.status == 'Pending' ? (
                                  <div class="Pending1">
                                    <svg
                                      width="10"
                                      height="10"
                                      viewBox="0 0 10 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                        fill="#FF6F6F"
                                      />
                                    </svg>
                                    &nbsp; Pending verification
                                  </div>
                                ) : (
                                  <div class="verified1">
                                    <a class="tooltipSTS" role="button">
                                      <img src="img/verifed-checked-icon.svg" />
                                      <span>Document verified</span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                            <p class="UploadedTime">
                              Uploaded on:{' '}
                              {handoverData[0]?.createdDate
                                ? moment(handoverData[0]?.createdDate).format(
                                  'Do  MMMM YYYY , h:mA',
                                )
                                : 'N/A'}{' '}
                              {handoverData[0]?.createdBy?.name
                                ? '| By :  ' + handoverData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          <div class="DocStatusCardsBody">
                            <p class="UpdatedTime">
                              Last updated by:{' '}
                              {handoverData[0]?.modifiedDate
                                ? moment(handoverData[0]?.modifiedDate).format(
                                  'h:mA, Do  MMMM YYYY',
                                )
                                : handoverData[0]?.createdDate
                                  ? handoverData[0]?.createdDate
                                  : 'N/A'}
                              {handoverData[0]?.createdBy?.name
                                ? ',' +
                                ' ' +
                                ' ' +
                                handoverData[0]?.createdBy?.name
                                : ''}
                            </p>
                          </div>
                          {handoverData[0]?.url != '' &&
                            handoverData[0]?.url != undefined ? (
                            <div class="DocStatusCardsFoot">
                              <div class="d-flex justify-content-between align-items-center">
                                <a class="FileName" role="button">
                                  <svg
                                    width="14"
                                    height="8"
                                    viewBox="0 0 14 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                      fill="#808080"
                                    />
                                  </svg>
                                  &nbsp;&nbsp;
                                  {/* {signatureData[0]?.url?.split('/').pop()} */}
                                  Attachment
                                </a>

                                <SwButton
                                  size="sm"
                                  target="_blank"
                                  variant="dark"
                                  icon={<i className="bi bi-arrow-right" />}
                                  iconPosition="start"
                                  href={handoverData[0]?.url}
                                >
                                  View
                                </SwButton>
                              </div>
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {!panCardData.length > 0 &&
                      !photoIdData.length > 0 &&
                      !addressData.length > 0 &&
                      !personAddressData.length > 0 &&
                      !boardResolutionData.length > 0 &&
                      !businessLicenseData.length > 0 &&
                      !incorporationData.length > 0 &&
                      !aggrementDocumentData.length > 0 &&
                      !termAndConditionData.length > 0 &&
                      !expansionData.length > 0 &&
                      !loiData.length > 0 &&
                      !expansionData.length > 0 &&
                      !signatureData.length > 0 &&
                      !handoverData.length > 0 ? (
                      <SwNoData />
                    ) : (
                      ''
                    )}
                  </div>
                ) : //KYC DOC
                  tab == 'kyc' ? (
                    <div class="row">
                      {/* <!-- Pending Doc Status Card --> */}
                      {panCardData.length > 0 ? (
                        <div class="col-md-4">
                          <div class="DocStatusCards">
                            {panCardData[0]?.createdDate &&
                              moment(panCardData[0]?.createdDate).format(
                                'YYYY-MM-DD',
                              ) >
                              moment()
                                .subtract(1, 'months')
                                .format('YYYY-MM-DD') ? (
                              <div class="BadgeForNew">New</div>
                            ) : (
                              ''
                            )}{' '}
                            <div class="DocStatusCardsHead">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="DocType">PAN Card</div>
                                <div class="DocStatus">
                                  {panCardData[0]?.status == 'Pending' ? (
                                    <div class="Pending1">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                          fill="#FF6F6F"
                                        />
                                      </svg>
                                      &nbsp; Pending verification
                                    </div>
                                  ) : (
                                    <div class="verified1">
                                      <a class="tooltipSTS" role="button">
                                        <img src="img/verifed-checked-icon.svg" />
                                        <span>Document verified</span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p class="UploadedTime">
                                Uploaded on:{' '}
                                {panCardData[0]?.createdDate
                                  ? moment(panCardData[0]?.createdDate).format(
                                    'Do  MMMM YYYY , h:mA',
                                  )
                                  : 'N/A'}{' '}
                                {panCardData[0]?.createdBy?.name
                                  ? '| By :  ' + panCardData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            <div class="DocStatusCardsBody">
                              <p class="UpdatedTime">
                                Last updated by:{' '}
                                {panCardData[0]?.modifiedDate
                                  ? moment(panCardData[0]?.modifiedDate).format(
                                    'h:mA, Do  MMMM YYYY',
                                  )
                                  : panCardData[0]?.createdDate
                                    ? panCardData[0]?.createdDate
                                    : 'N/A'}
                                {panCardData[0]?.createdBy?.name
                                  ? ',' +
                                  ' ' +
                                  ' ' +
                                  panCardData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            {panCardData[0]?.url != '' &&
                              panCardData[0]?.url != undefined ? (
                              <div class="DocStatusCardsFoot">
                                <div class="d-flex justify-content-between align-items-center">
                                  <a class="FileName" role="button">
                                    <svg
                                      width="14"
                                      height="8"
                                      viewBox="0 0 14 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                        fill="#808080"
                                      />
                                    </svg>
                                    {/* {panCardData[0]?.url?.split('/').pop()} */}
                                    Attachment
                                  </a>

                                  <SwButton
                                    size="sm"
                                    target="_blank"
                                    variant="dark"
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="start"
                                    href={panCardData[0]?.url}
                                  >
                                    View
                                  </SwButton>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {/* <!-- Verified Doc Status Card --> */}
                      {photoIdData.length > 0 ? (
                        <div class="col-md-4">
                          <div class="DocStatusCards">
                            {photoIdData[0]?.createdDate &&
                              moment(photoIdData[0]?.createdDate).format(
                                'YYYY-MM-DD',
                              ) >
                              moment()
                                .subtract(1, 'months')
                                .format('YYYY-MM-DD') ? (
                              <div class="BadgeForNew">New</div>
                            ) : (
                              ''
                            )}{' '}
                            <div class="DocStatusCardsHead">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="DocType">Photo Id Proof</div>
                                <div class="DocStatus">
                                  {photoIdData[0]?.status == 'Pending' ? (
                                    <div class="Pending1">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                          fill="#FF6F6F"
                                        />
                                      </svg>
                                      &nbsp; Pending verification
                                    </div>
                                  ) : (
                                    <div class="verified1">
                                      <a class="tooltipSTS" role="button">
                                        <img src="img/verifed-checked-icon.svg" />
                                        <span>Document verified</span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p class="UploadedTime">
                                Uploaded on:{' '}
                                {photoIdData[0]?.createdDate
                                  ? moment(photoIdData[0]?.createdDate).format(
                                    'Do  MMMM YYYY , h:mA',
                                  )
                                  : 'N/A'}{' '}
                                {photoIdData[0]?.createdBy?.name
                                  ? '| By :  ' + photoIdData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            <div class="DocStatusCardsBody">
                              <p class="UpdatedTime">
                                Last updated by:{' '}
                                {photoIdData[0]?.modifiedDate
                                  ? moment(photoIdData[0]?.modifiedDate).format(
                                    'h:mA, Do  MMMM YYYY',
                                  )
                                  : photoIdData[0]?.createdDate
                                    ? photoIdData[0]?.createdDate
                                    : 'N/A'}
                                {photoIdData[0]?.createdBy?.name
                                  ? ',' +
                                  ' ' +
                                  ' ' +
                                  photoIdData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            {photoIdData[0]?.url != '' &&
                              photoIdData[0]?.url != undefined ? (
                              <div class="DocStatusCardsFoot">
                                <div class="d-flex justify-content-between align-items-center">
                                  <a class="FileName" role="button">
                                    <svg
                                      width="14"
                                      height="8"
                                      viewBox="0 0 14 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                        fill="#808080"
                                      />
                                    </svg>
                                    {/* {photoIdData[0]?.url?.split('/').pop()} */}
                                    Attachment
                                  </a>

                                  <SwButton
                                    size="sm"
                                    target="_blank"
                                    variant="dark"
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="start"
                                    href={photoIdData[0]?.url}
                                  >
                                    View
                                  </SwButton>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {/* <!-- Verified Doc Status Card --> */}
                      {addressData.length > 0 ? (
                        <div class="col-md-4">
                          <div class="DocStatusCards">
                            {addressData[0]?.createdDate &&
                              moment(addressData[0]?.createdDate).format(
                                'YYYY-MM-DD',
                              ) >
                              moment()
                                .subtract(1, 'months')
                                .format('YYYY-MM-DD') ? (
                              <div class="BadgeForNew">New</div>
                            ) : (
                              ''
                            )}{' '}
                            <div class="DocStatusCardsHead">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="DocType">Address Proof</div>
                                <div class="DocStatus">
                                  {addressData[0]?.status == 'Pending' ? (
                                    <div class="Pending1">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                          fill="#FF6F6F"
                                        />
                                      </svg>
                                      &nbsp; Pending verification
                                    </div>
                                  ) : (
                                    <div class="verified1">
                                      <a class="tooltipSTS" role="button">
                                        <img src="img/verifed-checked-icon.svg" />
                                        <span>Document verified</span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p class="UploadedTime">
                                Uploaded on:{' '}
                                {addressData[0]?.createdDate
                                  ? moment(addressData[0]?.createdDate).format(
                                    'Do  MMMM YYYY , h:mA',
                                  )
                                  : 'N/A'}{' '}
                                | By: {addressData[0]?.createdBy?.name}
                              </p>
                            </div>
                            <div class="DocStatusCardsBody">
                              <p class="UpdatedTime">
                                Last updated by:{' '}
                                {addressData[0]?.modifiedDate
                                  ? moment(addressData[0]?.modifiedDate).format(
                                    'h:mA, Do  MMMM YYYY',
                                  )
                                  : addressData[0]?.createdDate
                                    ? addressData[0]?.createdDate
                                    : 'N/A'}
                                {addressData[0]?.createdBy?.name
                                  ? ',' +
                                  ' ' +
                                  ' ' +
                                  addressData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            {addressData[0]?.url != '' &&
                              addressData[0]?.url != undefined ? (
                              <div class="DocStatusCardsFoot">
                                <div class="d-flex justify-content-between align-items-center">
                                  <a class="FileName" role="button">
                                    <svg
                                      width="14"
                                      height="8"
                                      viewBox="0 0 14 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                        fill="#808080"
                                      />
                                    </svg>
                                    {/* {addressData[0]?.url?.split('/').pop()} */}
                                    Attachment
                                  </a>

                                  <SwButton
                                    size="sm"
                                    target="_blank"
                                    variant="dark"
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="start"
                                    href={addressData[0]?.url}
                                  >
                                    View
                                  </SwButton>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {/* <!-- Pending Doc Status Card --> */}
                      {personAddressData.length > 0 ? (
                        <div class="col-md-4">
                          <div class="DocStatusCards">
                            {personAddressData[0]?.createdDate &&
                              moment(personAddressData[0]?.createdDate).format(
                                'YYYY-MM-DD',
                              ) >
                              moment()
                                .subtract(1, 'months')
                                .format('YYYY-MM-DD') ? (
                              <div class="BadgeForNew">New</div>
                            ) : (
                              ''
                            )}{' '}
                            <div class="DocStatusCardsHead">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="DocType">
                                  Address Proof of Authorized Person
                                </div>
                                <div class="DocStatus">
                                  {personAddressData[0]?.status == 'Pending' ? (
                                    <div class="Pending1">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                          fill="#FF6F6F"
                                        />
                                      </svg>
                                      &nbsp; Pending verification
                                    </div>
                                  ) : (
                                    <div class="verified1">
                                      <a class="tooltipSTS" role="button">
                                        <img src="img/verifed-checked-icon.svg" />
                                        <span>Document verified</span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p class="UploadedTime">
                                Uploaded on:{' '}
                                {personAddressData[0]?.createdDate
                                  ? moment(
                                    personAddressData[0]?.createdDate,
                                  ).format('Do  MMMM YYYY , h:mA')
                                  : 'N/A'}{' '}
                                | By: {personAddressData[0]?.createdBy?.name}
                              </p>
                            </div>
                            <div class="DocStatusCardsBody">
                              <p class="UpdatedTime">
                                Last updated by:{' '}
                                {personAddressData[0]?.modifiedDate
                                  ? moment(
                                    personAddressData[0]?.modifiedDate,
                                  ).format('h:mA, Do  MMMM YYYY')
                                  : personAddressData[0]?.createdDate
                                    ? personAddressData[0]?.createdDate
                                    : 'N/A'}
                                {personAddressData[0]?.createdBy?.name
                                  ? ',' +
                                  ' ' +
                                  ' ' +
                                  personAddressData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            {personAddressData[0]?.url != '' &&
                              personAddressData[0]?.url != undefined ? (
                              <div class="DocStatusCardsFoot">
                                <div class="d-flex justify-content-between align-items-center">
                                  <a class="FileName" role="button">
                                    <svg
                                      width="14"
                                      height="8"
                                      viewBox="0 0 14 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                        fill="#808080"
                                      />
                                    </svg>
                                    {/* {personAddressData[0]?.url?.split('/').pop()} */}
                                    Attachment
                                  </a>

                                  <SwButton
                                    size="sm"
                                    target="_blank"
                                    variant="dark"
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="start"
                                    href={personAddressData[0]?.url}
                                  >
                                    View
                                  </SwButton>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}

                      {/* <!-- Verified Doc Status Card --> */}
                      {boardResolutionData.length > 0 ? (
                        <div class="col-md-4">
                          <div class="DocStatusCards">
                            {aggrementDetails?.boardResolutionData?.createdDate &&
                              moment(
                                aggrementDetails?.boardResolutionData?.createdDate,
                              ).format('YYYY-MM-DD') >
                              moment()
                                .subtract(1, 'months')
                                .format('YYYY-MM-DD') ? (
                              <div class="BadgeForNew">New</div>
                            ) : (
                              ''
                            )}{' '}
                            <div class="DocStatusCardsHead">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="DocType">Board Resolution</div>
                                <div class="DocStatus">
                                  {aggrementDetails?.boardResolutionData
                                    ?.status == 'Pending' ? (
                                    <div class="Pending1">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                          fill="#FF6F6F"
                                        />
                                      </svg>
                                      &nbsp; Pending verification
                                    </div>
                                  ) : (
                                    <div class="verified1">
                                      <a class="tooltipSTS" role="button">
                                        <img src="img/verifed-checked-icon.svg" />
                                        <span>Document verified</span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p class="UploadedTime">
                                Uploaded on:{' '}
                                {aggrementDetails?.boardResolutionData
                                  ?.createdDate
                                  ? moment(
                                    aggrementDetails?.boardResolutionData
                                      ?.createdDate,
                                  ).format('Do MMMM YYYY , h:mA')
                                  : 'N/A'}
                                {aggrementDetails?.boardResolutionData?.createdBy
                                  ?.name
                                  ? '| By :  ' +
                                  aggrementDetails?.boardResolutionData
                                    ?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            <div class="DocStatusCardsBody">
                              <p class="UpdatedTime">
                                Last updated by:{' '}
                                {aggrementDetails?.boardResolutionData
                                  ?.modifiedDate
                                  ? moment(
                                    aggrementDetails?.boardResolutionData
                                      ?.modifiedDate,
                                  ).format('h:mA, Do  MMMM YYYY')
                                  : aggrementDetails?.boardResolutionData
                                    ?.createdDate
                                    ? aggrementDetails?.boardResolutionData
                                      ?.createdDate
                                    : 'N/A'}
                                {aggrementDetails?.boardResolutionData?.createdBy
                                  ?.name
                                  ? ',' +
                                  ' ' +
                                  ' ' +
                                  aggrementDetails?.boardResolutionData
                                    ?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            {aggrementDetails?.boardResolutionData?.url != '' &&
                              aggrementDetails?.boardResolutionData?.url !=
                              undefined ? (
                              <div class="DocStatusCardsFoot">
                                <div class="d-flex justify-content-between align-items-center">
                                  <a class="FileName" role="button">
                                    <svg
                                      width="14"
                                      height="8"
                                      viewBox="0 0 14 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                        fill="#808080"
                                      />
                                    </svg>
                                    {/* {aggrementDetails?.boardResolutionData?.url?.split('/').pop()} */}
                                    Attachment
                                  </a>

                                  <SwButton
                                    size="sm"
                                    target="_blank"
                                    variant="dark"
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="start"
                                    href={
                                      aggrementDetails?.boardResolutionData?.url
                                    }
                                  >
                                    View
                                  </SwButton>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {/* <!-- Verified Doc Status Card --> */}
                      {businessLicenseData.length > 0 ? (
                        <div class="col-md-4">
                          <div class="DocStatusCards">
                            {businessLicenseData[0]?.createdDate &&
                              moment(businessLicenseData[0]?.createdDate).format(
                                'YYYY-MM-DD',
                              ) >
                              moment()
                                .subtract(1, 'months')
                                .format('YYYY-MM-DD') ? (
                              <div class="BadgeForNew">New</div>
                            ) : (
                              ''
                            )}{' '}
                            <div class="DocStatusCardsHead">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="DocType">Business License</div>
                                <div class="DocStatus">
                                  {businessLicenseData[0]?.status == 'Pending' ? (
                                    <div class="Pending1">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                          fill="#FF6F6F"
                                        />
                                      </svg>
                                      &nbsp; Pending verification
                                    </div>
                                  ) : (
                                    <div class="verified1">
                                      <a class="tooltipSTS" role="button">
                                        <img src="img/verifed-checked-icon.svg" />
                                        <span>Document verified</span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p class="UploadedTime">
                                Uploaded on:{' '}
                                {businessLicenseData[0]?.createdDate
                                  ? moment(
                                    businessLicenseData[0]?.createdDate,
                                  ).format('Do  MMMM YYYY , h:mA')
                                  : 'N/A'}{' '}
                                {businessLicenseData[0]?.createdBy?.name
                                  ? '| By :  ' +
                                  businessLicenseData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            <div class="DocStatusCardsBody">
                              <p class="UpdatedTime">
                                Last updated by:{' '}
                                {businessLicenseData[0]?.modifiedDate
                                  ? moment(
                                    businessLicenseData[0]?.modifiedDate,
                                  ).format('h:mA, Do  MMMM YYYY')
                                  : businessLicenseData[0]?.createdDate
                                    ? businessLicenseData[0]?.createdDate
                                    : 'N/A'}
                                {businessLicenseData[0]?.createdBy?.name
                                  ? ',' +
                                  ' ' +
                                  ' ' +
                                  businessLicenseData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            {businessLicenseData[0]?.url != '' &&
                              businessLicenseData[0]?.url != undefined ? (
                              <div class="DocStatusCardsFoot">
                                <div class="d-flex justify-content-between align-items-center">
                                  <a class="FileName" role="button">
                                    <svg
                                      width="14"
                                      height="8"
                                      viewBox="0 0 14 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                        fill="#808080"
                                      />
                                    </svg>
                                    {/* {businessLicenseData[0]?.url?.split('/').pop()} */}
                                    Attachment
                                  </a>

                                  <SwButton
                                    size="sm"
                                    target="_blank"
                                    variant="dark"
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="start"
                                    href={businessLicenseData[0]?.url}
                                  >
                                    View
                                  </SwButton>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {/* <!-- Verified Doc Status Card --> */}
                      {incorporationData.length > 0 ? (
                        <div class="col-md-4">
                          <div class="DocStatusCards">
                            {incorporationData[0]?.createdDate &&
                              moment(incorporationData[0]?.createdDate).format(
                                'YYYY-MM-DD',
                              ) >
                              moment()
                                .subtract(1, 'months')
                                .format('YYYY-MM-DD') ? (
                              <div class="BadgeForNew">New</div>
                            ) : (
                              ''
                            )}{' '}
                            <div class="DocStatusCardsHead">
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="DocType">
                                  Incorporation Certificate
                                </div>
                                <div class="DocStatus">
                                  {incorporationData[0]?.status == 'Pending' ? (
                                    <div class="Pending1">
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                          fill="#FF6F6F"
                                        />
                                      </svg>
                                      &nbsp; Pending verification
                                    </div>
                                  ) : (
                                    <div class="verified1">
                                      <a class="tooltipSTS" role="button">
                                        <img src="img/verifed-checked-icon.svg" />
                                        <span>Document verified</span>
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p class="UploadedTime">
                                Uploaded on:{' '}
                                {incorporationData[0]?.createdDate
                                  ? moment(
                                    incorporationData[0]?.createdDate,
                                  ).format('Do  MMMM YYYY , h:mA')
                                  : 'N/A'}{' '}
                                {incorporationData[0]?.createdBy?.name
                                  ? '| By :  ' +
                                  incorporationData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            <div class="DocStatusCardsBody">
                              <p class="UpdatedTime">
                                Last updated by:{' '}
                                {incorporationData[0]?.modifiedDate
                                  ? moment(
                                    incorporationData[0]?.modifiedDate,
                                  ).format('h:mA, Do  MMMM YYYY')
                                  : incorporationData[0]?.createdDate
                                    ? incorporationData[0]?.createdDate
                                    : 'N/A'}
                                {incorporationData[0]?.createdBy?.name
                                  ? ',' +
                                  ' ' +
                                  ' ' +
                                  incorporationData[0]?.createdBy?.name
                                  : ''}
                              </p>
                            </div>
                            {incorporationData[0]?.url != '' &&
                              incorporationData[0]?.url != undefined ? (
                              <div class="DocStatusCardsFoot">
                                <div class="d-flex justify-content-between align-items-center">
                                  <a class="FileName" role="button">
                                    <svg
                                      width="14"
                                      height="8"
                                      viewBox="0 0 14 8"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                        fill="#808080"
                                      />
                                    </svg>
                                    {/* {incorporationData[0]?.url?.split('/').pop()} */}
                                    Attachment
                                  </a>

                                  <SwButton
                                    size="sm"
                                    target="_blank"
                                    variant="dark"
                                    icon={<i className="bi bi-arrow-right" />}
                                    iconPosition="start"
                                    href={incorporationData[0]?.url}
                                  >
                                    View
                                  </SwButton>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      {!panCardData.length > 0 &&
                        !photoIdData.length > 0 &&
                        !addressData.length > 0 &&
                        !personAddressData.length > 0 &&
                        !boardResolutionData.length > 0 &&
                        !businessLicenseData.length > 0 &&
                        !incorporationData.length > 0 ? (
                        <SwNoData />
                      ) : (
                        ''
                      )}
                    </div>
                  ) : //LEGAL DOC
                    tab == 'legal' ? (
                      <div class="row">
                        {aggrementDocumentData.length > 0 ? (
                          <div class="col-md-4">
                            <div class="DocStatusCards">
                              {aggrementDocumentData[0]?.createdDate &&
                                moment(aggrementDocumentData[0]?.createdDate).format(
                                  'YYYY-MM-DD',
                                ) >
                                moment()
                                  .subtract(1, 'months')
                                  .format('YYYY-MM-DD') ? (
                                <div class="BadgeForNew">New</div>
                              ) : (
                                ''
                              )}{' '}
                              <div class="DocStatusCardsHead">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="DocType">Aggrement Document</div>
                                  <div class="DocStatus">
                                    {aggrementDocumentData[0]?.status ==
                                      'Pending' ? (
                                      <div class="Pending1">
                                        <svg
                                          width="10"
                                          height="10"
                                          viewBox="0 0 10 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                            fill="#FF6F6F"
                                          />
                                        </svg>
                                        &nbsp; Pending verification
                                      </div>
                                    ) : (
                                      <div class="verified1">
                                        <a class="tooltipSTS" role="button">
                                          <img src="img/verifed-checked-icon.svg" />
                                          <span>Document verified</span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <p class="UploadedTime">
                                  Uploaded on:{' '}
                                  {aggrementDocumentData[0]?.createdDate
                                    ? moment(
                                      aggrementDocumentData[0]?.createdDate,
                                    ).format('Do  MMMM YYYY , h:mA')
                                    : 'N/A'}{' '}
                                  {aggrementDocumentData[0]?.createdBy?.name
                                    ? '| By :  ' +
                                    aggrementDocumentData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              <div class="DocStatusCardsBody">
                                <p class="UpdatedTime">
                                  Last updated by:{' '}
                                  {aggrementDocumentData[0]?.modifiedDate
                                    ? moment(
                                      aggrementDocumentData[0]?.modifiedDate,
                                    ).format('h:mA, Do  MMMM YYYY')
                                    : aggrementDocumentData[0]?.createdDate
                                      ? aggrementDocumentData[0]?.createdDate
                                      : 'N/A'}
                                  {aggrementDocumentData[0]?.createdBy?.name
                                    ? ',' +
                                    ' ' +
                                    ' ' +
                                    aggrementDocumentData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              {aggrementDocumentData[0]?.url != '' &&
                                aggrementDocumentData[0]?.url != undefined ? (
                                <div class="DocStatusCardsFoot">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <a class="FileName" role="button">
                                      <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                          fill="#808080"
                                        />
                                      </svg>
                                      &nbsp;&nbsp;
                                      {/* {aggrementDocumentData[0]?.url?.split('/').pop()} */}
                                      Attachment
                                    </a>

                                    <SwButton
                                      size="sm"
                                      target="_blank"
                                      variant="dark"
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="start"
                                      href={aggrementDocumentData[0]?.url}
                                    >
                                      View
                                    </SwButton>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {termAndConditionData.length > 0 ? (
                          <div class="col-md-4">
                            <div class="DocStatusCards">
                              {termAndConditionData[0]?.createdDate &&
                                moment(termAndConditionData[0]?.createdDate).format(
                                  'YYYY-MM-DD',
                                ) >
                                moment()
                                  .subtract(1, 'months')
                                  .format('YYYY-MM-DD') ? (
                                <div class="BadgeForNew">New</div>
                              ) : (
                                ''
                              )}{' '}
                              <div class="DocStatusCardsHead">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="DocType">T&C Document</div>
                                  <div class="DocStatus">
                                    {termAndConditionData[0]?.status ==
                                      'Pending' ? (
                                      <div class="Pending1">
                                        <svg
                                          width="10"
                                          height="10"
                                          viewBox="0 0 10 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                            fill="#FF6F6F"
                                          />
                                        </svg>
                                        &nbsp; Pending verification
                                      </div>
                                    ) : (
                                      <div class="verified1">
                                        <a class="tooltipSTS" role="button">
                                          <img src="img/verifed-checked-icon.svg" />
                                          <span>Document verified</span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <p class="UploadedTime">
                                  Uploaded on:{' '}
                                  {termAndConditionData[0]?.createdDate
                                    ? moment(
                                      termAndConditionData[0]?.createdDate,
                                    ).format('Do  MMMM YYYY , h:mA')
                                    : 'N/A'}{' '}
                                  {termAndConditionData[0]?.createdBy?.name
                                    ? '| By :  ' +
                                    termAndConditionData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              <div class="DocStatusCardsBody">
                                <p class="UpdatedTime">
                                  Last updated by:{' '}
                                  {termAndConditionData[0]?.modifiedDate
                                    ? moment(
                                      termAndConditionData[0]?.modifiedDate,
                                    ).format('h:mA, Do  MMMM YYYY')
                                    : termAndConditionData[0]?.createdDate
                                      ? termAndConditionData[0]?.createdDate
                                      : 'N/A'}
                                  {termAndConditionData[0]?.createdBy?.name
                                    ? ',' +
                                    ' ' +
                                    ' ' +
                                    termAndConditionData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              {termAndConditionData[0]?.url != '' &&
                                termAndConditionData[0]?.url != undefined ? (
                                <div class="DocStatusCardsFoot">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <a class="FileName" role="button">
                                      <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                          fill="#808080"
                                        />
                                      </svg>
                                      &nbsp;&nbsp;
                                      {/* {termAndConditionData[0]?.url?.split('/').pop()} */}
                                      Attachment
                                    </a>

                                    <SwButton
                                      size="sm"
                                      target="_blank"
                                      variant="dark"
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="start"
                                      href={termAndConditionData[0]?.url}
                                    >
                                      View
                                    </SwButton>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {expansionData.length > 0 ? (
                          <div class="col-md-4">
                            <div class="DocStatusCards">
                              {expansionData[0]?.createdDate &&
                                moment(expansionData[0]?.createdDate).format(
                                  'YYYY-MM-DD',
                                ) >
                                moment()
                                  .subtract(1, 'months')
                                  .format('YYYY-MM-DD') ? (
                                <div class="BadgeForNew">New</div>
                              ) : (
                                ''
                              )}{' '}
                              <div class="DocStatusCardsHead">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="DocType">Addendum Document</div>
                                  <div class="DocStatus">
                                    {expansionData[0]?.status == 'Pending' ? (
                                      <div class="Pending1">
                                        <svg
                                          width="10"
                                          height="10"
                                          viewBox="0 0 10 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                            fill="#FF6F6F"
                                          />
                                        </svg>
                                        &nbsp; Pending verification
                                      </div>
                                    ) : (
                                      <div class="verified1">
                                        <a class="tooltipSTS" role="button">
                                          <img src="img/verifed-checked-icon.svg" />
                                          <span>Document verified</span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <p class="UploadedTime">
                                  Uploaded on:{' '}
                                  {expansionData[0]?.createdDate
                                    ? moment(expansionData[0]?.createdDate).format(
                                      'Do  MMMM YYYY , h:mA',
                                    )
                                    : 'N/A'}{' '}
                                  {expansionData[0]?.createdBy?.name
                                    ? '| By :  ' + expansionData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              <div class="DocStatusCardsBody">
                                <p class="UpdatedTime">
                                  Last updated by:{' '}
                                  {expansionData[0]?.modifiedDate
                                    ? moment(expansionData[0]?.modifiedDate).format(
                                      'h:mA, Do  MMMM YYYY',
                                    )
                                    : expansionData[0]?.createdDate
                                      ? expansionData[0]?.createdDate
                                      : 'N/A'}
                                  {expansionData[0]?.createdBy?.name
                                    ? ',' +
                                    ' ' +
                                    ' ' +
                                    expansionData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              {expansionData[0]?.url != '' &&
                                expansionData[0]?.url != undefined ? (
                                <div class="DocStatusCardsFoot">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <a class="FileName" role="button">
                                      <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                          fill="#808080"
                                        />
                                      </svg>
                                      &nbsp;&nbsp;
                                      {/* {expansionData[0]?.url?.split('/').pop()} */}
                                      Attachment
                                    </a>

                                    <SwButton
                                      size="sm"
                                      target="_blank"
                                      variant="dark"
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="start"
                                      href={expansionData[0]?.url}
                                    >
                                      View
                                    </SwButton>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {loiData.length > 0 ? (
                          <div class="col-md-4">
                            <div class="DocStatusCards">
                              {loiData[0]?.createdDate &&
                                moment(loiData[0]?.createdDate).format('YYYY-MM-DD') >
                                moment()
                                  .subtract(1, 'months')
                                  .format('YYYY-MM-DD') ? (
                                <div class="BadgeForNew">New</div>
                              ) : (
                                ''
                              )}{' '}
                              <div class="DocStatusCardsHead">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="DocType">LOI Document</div>
                                  <div class="DocStatus">
                                    {loiData[0]?.status == 'Pending' ? (
                                      <div class="Pending1">
                                        <svg
                                          width="10"
                                          height="10"
                                          viewBox="0 0 10 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                            fill="#FF6F6F"
                                          />
                                        </svg>
                                        &nbsp; Pending verification
                                      </div>
                                    ) : (
                                      <div class="verified1">
                                        <a class="tooltipSTS" role="button">
                                          <img src="img/verifed-checked-icon.svg" />
                                          <span>Document verified</span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <p class="UploadedTime">
                                  Uploaded on:{' '}
                                  {loiData[0]?.createdDate
                                    ? moment(loiData[0]?.createdDate).format(
                                      'Do  MMMM YYYY , h:mA',
                                    )
                                    : 'N/A'}{' '}
                                  {loiData[0]?.createdBy?.name
                                    ? '| By :  ' + loiData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              <div class="DocStatusCardsBody">
                                <p class="UpdatedTime">
                                  Last updated by:{' '}
                                  {loiData[0]?.modifiedDate
                                    ? moment(loiData[0]?.modifiedDate).format(
                                      'h:mA, Do  MMMM YYYY',
                                    )
                                    : loiData[0]?.createdDate
                                      ? loiData[0]?.createdDate
                                      : 'N/A'}
                                  {loiData[0]?.createdBy?.name
                                    ? ',' + ' ' + ' ' + loiData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              {loiData[0]?.url != '' &&
                                loiData[0]?.url != undefined ? (
                                <div class="DocStatusCardsFoot">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <a class="FileName" role="button">
                                      <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                          fill="#808080"
                                        />
                                      </svg>
                                      &nbsp;&nbsp;
                                      {/* {loiData[0]?.url?.split('/').pop()} */}
                                      Attachment
                                    </a>

                                    <SwButton
                                      size="sm"
                                      target="_blank"
                                      variant="dark"
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="start"
                                      href={loiData[0]?.url}
                                    >
                                      View
                                    </SwButton>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {expansionData.length > 0 ? (
                          <div class="col-md-4">
                            <div class="DocStatusCards">
                              {expansionData[0]?.createdDate &&
                                moment(expansionData[0]?.createdDate).format(
                                  'YYYY-MM-DD',
                                ) >
                                moment()
                                  .subtract(1, 'months')
                                  .format('YYYY-MM-DD') ? (
                                <div class="BadgeForNew">New</div>
                              ) : (
                                ''
                              )}{' '}
                              <div class="DocStatusCardsHead">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="DocType">Expansion Document</div>
                                  <div class="DocStatus">
                                    {expansionData[0]?.status == 'Pending' ? (
                                      <div class="Pending1">
                                        <svg
                                          width="10"
                                          height="10"
                                          viewBox="0 0 10 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                            fill="#FF6F6F"
                                          />
                                        </svg>
                                        &nbsp; Pending verification
                                      </div>
                                    ) : (
                                      <div class="verified1">
                                        <a class="tooltipSTS" role="button">
                                          <img src="img/verifed-checked-icon.svg" />
                                          <span>Document verified</span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <p class="UploadedTime">
                                  Uploaded on:{' '}
                                  {expansionData[0]?.createdDate
                                    ? moment(expansionData[0]?.createdDate).format(
                                      'Do  MMMM YYYY , h:mA',
                                    )
                                    : 'N/A'}{' '}
                                  {expansionData[0]?.createdBy?.name
                                    ? '| By :  ' + expansionData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              <div class="DocStatusCardsBody">
                                <p class="UpdatedTime">
                                  Last updated by:{' '}
                                  {expansionData[0]?.modifiedDate
                                    ? moment(expansionData[0]?.modifiedDate).format(
                                      'h:mA, Do  MMMM YYYY',
                                    )
                                    : expansionData[0]?.createdDate
                                      ? expansionData[0]?.createdDate
                                      : 'N/A'}
                                  {expansionData[0]?.createdBy?.name
                                    ? ',' +
                                    ' ' +
                                    ' ' +
                                    expansionData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              {expansionData[0]?.url != '' &&
                                expansionData[0]?.url != undefined ? (
                                <div class="DocStatusCardsFoot">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <a class="FileName" role="button">
                                      <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                          fill="#808080"
                                        />
                                      </svg>
                                      &nbsp;&nbsp;
                                      {/* {expansionData[0]?.url?.split('/').pop()} */}
                                      Attachment
                                    </a>

                                    <SwButton
                                      size="sm"
                                      target="_blank"
                                      variant="dark"
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="start"
                                      href={expansionData[0]?.url}
                                    >
                                      View
                                    </SwButton>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                        {signatureData.length > 0 ? (
                          <div class="col-md-4">
                            <div class="DocStatusCards">
                              {signatureData[0]?.createdDate &&
                                moment(signatureData[0]?.createdDate).format(
                                  'YYYY-MM-DD',
                                ) >
                                moment()
                                  .subtract(1, 'months')
                                  .format('YYYY-MM-DD') ? (
                                <div class="BadgeForNew">New</div>
                              ) : (
                                ''
                              )}{' '}
                              <div class="DocStatusCardsHead">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="DocType">Signed Aggrement</div>
                                  <div class="DocStatus">
                                    {signatureData[0]?.status == 'Pending' ? (
                                      <div class="Pending1">
                                        <svg
                                          width="10"
                                          height="10"
                                          viewBox="0 0 10 10"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                            fill="#FF6F6F"
                                          />
                                        </svg>
                                        &nbsp; Pending verification
                                      </div>
                                    ) : (
                                      <div class="verified1">
                                        <a class="tooltipSTS" role="button">
                                          <img src="img/verifed-checked-icon.svg" />
                                          <span>Document verified</span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <p class="UploadedTime">
                                  Uploaded on:{' '}
                                  {signatureData[0]?.createdDate
                                    ? moment(signatureData[0]?.createdDate).format(
                                      'Do  MMMM YYYY , h:m A',
                                    )
                                    : 'N/A'}
                                  {signatureData[0]?.createdBy?.name
                                    ? '| By :  ' + signatureData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              <div class="DocStatusCardsBody">
                                <p class="UpdatedTime">
                                  Last updated by:{' '}
                                  {signatureData[0]?.modifiedDate
                                    ? moment(signatureData[0]?.modifiedDate).format(
                                      'h:mA, Do  MMMM YYYY',
                                    )
                                    : signatureData[0]?.createdDate
                                      ? signatureData[0]?.createdDate
                                      : 'N/A'}
                                  {signatureData[0]?.createdBy?.name
                                    ? ',' +
                                    ' ' +
                                    ' ' +
                                    signatureData[0]?.createdBy?.name
                                    : ''}
                                </p>
                              </div>
                              {signatureData[0]?.url != '' &&
                                signatureData[0]?.url != undefined ? (
                                <div class="DocStatusCardsFoot">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <a class="FileName" role="button">
                                      <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                          fill="#808080"
                                        />
                                      </svg>
                                      &nbsp;&nbsp;
                                      {/* {signatureData[0]?.url?.split('/').pop()} */}
                                      Attachment
                                    </a>

                                    <SwButton
                                      size="sm"
                                      target="_blank"
                                      variant="dark"
                                      icon={<i className="bi bi-arrow-right" />}
                                      iconPosition="start"
                                      href={signatureData[0]?.url}
                                    >
                                      View
                                    </SwButton>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}

                        {!aggrementDocumentData.length > 0 &&
                          !termAndConditionData.length > 0 &&
                          !expansionData.length > 0 &&
                          !loiData.length > 0 &&
                          !expansionData.length > 0 &&
                          !signatureData.length > 0 ? (
                          <SwNoData />
                        ) : (
                          ''
                        )}
                      </div>
                    ) : //HANDOVER DOC
                      tab == 'handover' ? (
                        <div class="row">
                          {handoverData.length > 0 ? (
                            <div class="col-md-4">
                              <div class="DocStatusCards">
                                {handoverData[0]?.createdDate &&
                                  moment(handoverData[0]?.createdDate).format(
                                    'YYYY-MM-DD',
                                  ) >
                                  moment()
                                    .subtract(1, 'months')
                                    .format('YYYY-MM-DD') ? (
                                  <div class="BadgeForNew">New</div>
                                ) : (
                                  ''
                                )}{' '}
                                <div class="DocStatusCardsHead">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <div class="DocType">Handover Checklist</div>
                                    <div class="DocStatus">
                                      {handoverData[0]?.status == 'Pending' ? (
                                        <div class="Pending1">
                                          <svg
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M5 7.5C5.14167 7.5 5.2605 7.452 5.3565 7.356C5.45217 7.26033 5.5 7.14167 5.5 7C5.5 6.85833 5.45217 6.7395 5.3565 6.6435C5.2605 6.54783 5.14167 6.5 5 6.5C4.85833 6.5 4.73967 6.54783 4.644 6.6435C4.548 6.7395 4.5 6.85833 4.5 7C4.5 7.14167 4.548 7.26033 4.644 7.356C4.73967 7.452 4.85833 7.5 5 7.5ZM4.5 5.5H5.5V2.5H4.5V5.5ZM3.125 9.5L0.5 6.875V3.125L3.125 0.5H6.875L9.5 3.125V6.875L6.875 9.5H3.125ZM3.55 8.5H6.45L8.5 6.45V3.55L6.45 1.5H3.55L1.5 3.55V6.45L3.55 8.5Z"
                                              fill="#FF6F6F"
                                            />
                                          </svg>
                                          &nbsp; Pending verification
                                        </div>
                                      ) : (
                                        <div class="verified1">
                                          <a class="tooltipSTS" role="button">
                                            <img src="img/verifed-checked-icon.svg" />
                                            <span>Document verified</span>
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <p class="UploadedTime">
                                    Uploaded on:{' '}
                                    {handoverData[0]?.createdDate
                                      ? moment(handoverData[0]?.createdDate).format(
                                        'Do  MMMM YYYY , h:mA',
                                      )
                                      : 'N/A'}{' '}
                                    {handoverData[0]?.createdBy?.name
                                      ? '| By :  ' + handoverData[0]?.createdBy?.name
                                      : ''}
                                  </p>
                                </div>
                                <div class="DocStatusCardsBody">
                                  <p class="UpdatedTime">
                                    Last updated by:{' '}
                                    {handoverData[0]?.modifiedDate
                                      ? moment(handoverData[0]?.modifiedDate).format(
                                        'h:mA, Do  MMMM YYYY',
                                      )
                                      : handoverData[0]?.createdDate
                                        ? handoverData[0]?.createdDate
                                        : 'N/A'}
                                    {handoverData[0]?.createdBy?.name
                                      ? ',' +
                                      ' ' +
                                      ' ' +
                                      handoverData[0]?.createdBy?.name
                                      : ''}
                                  </p>
                                </div>
                                {handoverData[0]?.url != '' &&
                                  handoverData[0]?.url != undefined ? (
                                  <div class="DocStatusCardsFoot">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <a class="FileName" role="button">
                                        <svg
                                          width="14"
                                          height="8"
                                          viewBox="0 0 14 8"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M4.00004 7.66671C2.97782 7.66671 2.11115 7.31115 1.40004 6.60004C0.688929 5.88893 0.333374 5.02226 0.333374 4.00004C0.333374 2.97782 0.688929 2.11115 1.40004 1.40004C2.11115 0.68893 2.97782 0.333374 4.00004 0.333374H11C11.7334 0.333374 12.3612 0.594485 12.8834 1.11671C13.4056 1.63893 13.6667 2.26671 13.6667 3.00004C13.6667 3.73337 13.4056 4.36115 12.8834 4.88337C12.3612 5.4056 11.7334 5.66671 11 5.66671H4.66671C4.20004 5.66671 3.8056 5.5056 3.48337 5.18337C3.16115 4.86115 3.00004 4.46671 3.00004 4.00004C3.00004 3.53337 3.16115 3.13893 3.48337 2.81671C3.8056 2.49449 4.20004 2.33337 4.66671 2.33337H11V3.33337H4.66671C4.47782 3.33337 4.3196 3.39715 4.19204 3.52471C4.06404 3.65271 4.00004 3.81115 4.00004 4.00004C4.00004 4.18893 4.06404 4.34715 4.19204 4.47471C4.3196 4.60271 4.47782 4.66671 4.66671 4.66671H11C11.4667 4.66671 11.8612 4.5056 12.1834 4.18337C12.5056 3.86115 12.6667 3.46671 12.6667 3.00004C12.6667 2.53337 12.5056 2.13893 12.1834 1.81671C11.8612 1.49449 11.4667 1.33337 11 1.33337H4.00004C3.26671 1.33337 2.63893 1.59449 2.11671 2.11671C1.59449 2.63893 1.33337 3.26671 1.33337 4.00004C1.33337 4.73337 1.59449 5.36115 2.11671 5.88337C2.63893 6.4056 3.26671 6.66671 4.00004 6.66671H11V7.66671H4.00004Z"
                                            fill="#808080"
                                          />
                                        </svg>
                                        &nbsp;&nbsp;
                                        {/* {handoverData[0]?.url?.split('/').pop()} */}
                                        Attachment
                                      </a>

                                      <SwButton
                                        size="sm"
                                        target="_blank"
                                        variant="dark"
                                        icon={<i className="bi bi-arrow-right" />}
                                        iconPosition="start"
                                        href={handoverData[0]?.url}
                                      >
                                        View
                                      </SwButton>
                                    </div>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          ) : (
                            <SwNoData />
                          )}
                        </div>
                      ) : (
                        ''
                      )}
              </div>
            </div>
          </div>
        </Layout>
      </Layout>
    </>
  );
}
export default connect()(LegalAndCompliance);
